'use client';

import ServiceLayout from '@/components/layout/service/ServiceLayout';

interface HelloLayoutProps {
    children: React.ReactNode;
}

export default function layout({ children }: HelloLayoutProps) {
    return <ServiceLayout>{children}</ServiceLayout>;
}
